module.exports = __webpack_public_path__ + "static/media/giftBlueIcon.e11377c6.svg";